module.exports = __webpack_public_path__ + "img/20191122163601185.058b7b0e.jpg";